module.exports = __webpack_public_path__ + "img/Anisthenes_Pio-Clementino.0ee5bdf2.png";